import React, { useState } from 'react';
import styles from './PricingFAQ.module.scss';

const faqs = [
    {
        question: 'Why is it a one-time payment instead of a subscription?',
        answer:
            "We're in Early Access — we want to validate that Prepal works for students before locking anyone into a recurring commitment. The one-time payment gives you full access with zero risk. When we launch subscriptions later, early adopters automatically get 50% off for life.",
    },
    {
        question: "What if I'm not satisfied?",
        answer:
            "We offer a 14-day money-back guarantee. If you've used less than 10% of the content and aren't happy, contact support@prepal.ai within 14 days for a full refund. No questions asked.",
    },
    {
        question: 'Will I lose access when you switch to subscriptions?',
        answer:
            "No. Your Early Access purchase covers the entire Early Access period. When we transition to subscriptions, you'll be grandfathered in with a permanent 50% discount.",
    },
    {
        question: 'What payment methods do you accept?',
        answer:
            'We accept Visa, Mastercard, and other major payment methods through our secure payment processor. All prices are shown in both USD and VND for convenience.',
    },
    {
        question: 'Can I get a refund after 14 days?',
        answer:
            'After the 14-day window, refunds are handled on a case-by-case basis for technical issues only. See our full Refund Policy for details.',
    },
];

const PricingFAQ = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

    return (
        <section className={styles.section}>
            <div className={styles.contentWrapper}>
                <h2 className={styles.heading}>Pricing Questions</h2>
                <div className={styles.list}>
                    {faqs.map((faq, i) => {
                        const isOpen = openIndex === i;
                        return (
                            <div key={i} className={styles.item}>
                                <button
                                    className={styles.question}
                                    aria-expanded={isOpen}
                                    onClick={() => toggle(i)}
                                >
                                    <span>{faq.question}</span>
                                    <span
                                        className={styles.icon}
                                        style={{ transform: isOpen ? 'rotate(45deg)' : 'none' }}
                                        aria-hidden="true"
                                    >
                                        +
                                    </span>
                                </button>
                                {isOpen && <p className={styles.answer}>{faq.answer}</p>}
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default PricingFAQ;
